import { jsx as o } from "react/jsx-runtime";
import { memo as t } from "react";
import { ValueDescription as n } from "@biron-data/react-components";
import { TooltipContentDimension as e } from "../tooltipContent/TooltipContent.Dimension.js";
const D = t(function({
  dimension: i,
  getMoreInformationLink: r
}) {
  return /* @__PURE__ */ o(n, { children: /* @__PURE__ */ o(e, { dimension: i, getMoreInformationLink: r }) });
});
export {
  D as default
};
//# sourceMappingURL=DimensionDescription.js.map
